import i18n from '@dms/i18n';

import {Nullish} from 'shared/web';

import {PAIRED_RECORD_LOADING_PLACEHOLDER} from './PAIRED_RECORD_LOADING_PLACEHOLDER';

/**
 * Resolves a paired record's display code/number: the entity's own code when available,
 * the loading placeholder while the query is in flight, otherwise the not-found label.
 */
export const resolvePairedRecordCode = (code: string | Nullish, isLoading: boolean): string =>
  code ??
  (isLoading ? PAIRED_RECORD_LOADING_PLACEHOLDER : i18n.t('general.notifications.notFound'));
